import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import applicationPic from '../../../assets/images/applicationPic.png';

export const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Delay animation to ensure smooth transition
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-[80vh] bg-white flex items-center overflow-hidden pt-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left Column - Text Content */}
          <div className={`text-center lg:text-left transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <h1 className="text-4xl tracking-tight font-bold text-gray-900 sm:text-5xl md:text-6xl">
              <span className="block text-blue-500">Fast, Secure, Smart</span>
              <span className="block text-gray-900">Lead Gen Workflow</span>
            </h1>
            <p className="mt-6 text-lg text-gray-600 sm:mt-8 sm:text-xl leading-relaxed">
              Built for brokers & online lending companies. Accept online applications, automate financial
               analysis, and keep your CRM updated without lifting a finger.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row lg:justify-start justify-center gap-4">
              <Link
                to="/signup"
                className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-lg text-white bg-blue-500 hover:bg-blue-600 transition-colors shadow-lg hover:shadow-xl"
              >
                Get Started <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <a
                href="#demo"
                className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-lg text-blue-500 bg-blue-50 hover:bg-blue-100 transition-colors border border-blue-200"
              >
                Watch Demo
              </a>
            </div>
          </div>

          {/* Right Column - Image Overlay */}
          <div className={`relative hidden lg:block transition-all duration-800 ease-out delay-200 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-6'
          }`}>
            <div className="relative w-full h-[600px] flex items-center justify-center">
              {/* Background Image - applicationPic.png */}
              <div className="absolute inset-0 flex items-center justify-center">
                <img 
                  src={applicationPic} 
                  alt="Application Background"
                  className="w-full max-w-2xl h-auto object-contain drop-shadow-2xl"
                />
              </div>
              
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
